import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { TouchableOpacity } from 'react-native';
import { GenericEdited } from '@dbk/ui-icons';
import { View } from '@dbk/ui-react-utils';
import format from 'date-fns/format';
import { NavigationListItemHeader, NavigationListItemFooter, NavigationListItemContent } from '@dbk/ui-list';
import { Checkbox } from '@dbk/ui-forms';
import Text from '@dbk/ui-text';
import { PALETTE, DE } from '../../../../constants';
import styles from './advices.styles';
import { formatDate } from './utils';

const AdvicesRowItem = ((props) => {
    const { item } = props;
    const { auth: { langCode , documentPreviewDisabled}, i18n: { messages } } = props;  //WMCE-42437 -  Disabling Preview button for RM 
    const receivedDate = formatDate(item.transactionDate || item.receivedDate, langCode);

    return (
        <div className="docflexClass categoryText">
            <View style={{ flex: 0.9}} className="listColumn">
                <NavigationListItemHeader>
                    <Checkbox
                        name="advices_checkbox"
                        checked={item.isChecked}
                        className="checkboxClass"
                        onChange={() => props.handleDocumentCheckboxClick(item)}
                    />
                    <TouchableOpacity
                     onPress={() => props.handlePreviewClick(item)} 
                     disabled={documentPreviewDisabled}>
                        <Text numberOfLines={1}
                            ellipsizeMode={'tail'}
                            style={[{ color: '#ffffff' }, { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '400px' }]}>
                            {' ' + item.adviceDocumentName}
                        </Text>
                    </TouchableOpacity>
                </NavigationListItemHeader>

                <View className="docflexClassSecondary">
                    <NavigationListItemFooter className="rowFooter" secondary color={PALETTE.primaryInverseText}>
                        <Text tabIndex={0}> {(item.portfolioId ? item.portfolioId : '') + ` ` + (item.currency ? item.currency.ebLabelDesc : '')}</Text>
                    </NavigationListItemFooter>
                    {(
                        <NavigationListItemContent tabIndex={0} secondary color={PALETTE.primaryTextDisabled}
                            style={{ paddingRight: "10%" }}>{receivedDate}</NavigationListItemContent>
                    )}
                </View>
            </View>
            <View style={styles.pdfView} >
                <TouchableOpacity
                    onPress={() => props.handlePreviewClick(item)}
                    aria-label={messages['app.chedelivery.reports.viewAdvice']}
                    disabled={documentPreviewDisabled} 
                    style={(documentPreviewDisabled) ? styles.notAllowedCursor : styles.pointerCursor}>
                    <GenericEdited color={PALETTE.primaryTextDisabled}
                        height={34}
                        width={34}
                    />
                </TouchableOpacity>
            </View>
        </div >

    );
})

export default createContainer(
    {
        $queries: {
            auth: {
                langCode: true,
                documentPreviewDisabled: true
            },
            changePage: { $call: 'ui.history.replace' },
            app: {
                global: {
                    deviceInfo: {
                        isTablet: true
                    }
                }
            },
            i18n: {
                messages: true
            },
        }
    },
    ({ ui, ...queries }) => ({
        ...queries
    })
)(AdvicesRowItem);



